export const set_role = (role) => ({
  type: 'set_role',
  payload: role,
});
